import { FC, SVGProps } from "react";
import clsx from "clsx";

// ----------------------------------------------------------------------------------

export type ITwitterProps = SVGProps<SVGSVGElement> & {
  variant: "white" | "black" | "normal";
};

const Twitter: FC<ITwitterProps> = (props) => {
  const { variant, className, ...other } = props;

  return (
    <>
      {variant === "white" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 31 28"
          fill="none"
          className={clsx("rounded-sm bg-white p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <path
            d="M24.1006 0H28.7006L18.6006 11.8819L30.4006 28H21.1406L13.8906 18.2052L5.59063 28H0.990625L11.6906 15.2915L0.390625 0H9.88063L16.4306 8.9476L24.1006 0ZM22.4906 25.2103H25.0406L8.54063 2.68635H5.80062L22.4906 25.2103Z"
            fill="#054ADA"
          />
        </svg>
      )}

      {variant === "black" && (
        <svg
          width="25"
          height="25"
          viewBox="0 0 31 28"
          fill="none"
          className={clsx("rounded-sm bg-black-900 p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <path
            d="M24.1006 0H28.7006L18.6006 11.8819L30.4006 28H21.1406L13.8906 18.2052L5.59063 28H0.990625L11.6906 15.2915L0.390625 0H9.88063L16.4306 8.9476L24.1006 0ZM22.4906 25.2103H25.0406L8.54063 2.68635H5.80062L22.4906 25.2103Z"
            fill="#EFFBFF"
          />
        </svg>
      )}

      {variant === "normal" && (
        <svg
          width="31"
          height="28"
          viewBox="0 0 31 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <path
            d="M24.1006 0H28.7006L18.6006 11.8819L30.4006 28H21.1406L13.8906 18.2052L5.59063 28H0.990625L11.6906 15.2915L0.390625 0H9.88063L16.4306 8.9476L24.1006 0ZM22.4906 25.2103H25.0406L8.54063 2.68635H5.80062L22.4906 25.2103Z"
            fill="#5D5D5D"
          />
        </svg>
      )}
    </>
  );
};

export default Twitter;
